import { createContext, useState } from "react";
import { apiV1 } from "../lib/axios";
import { useAuth } from "../hooks/useAuth";
import { toast } from "react-toastify";
import { uploadS3 } from "../services/uploadS3";
import { fileToBase64 } from "../utils/fileToBase64";
import { getApiErrorMessage } from "../utils/getApiErrorMessage";

export const AccountContext = createContext({});

export function AccountProvider({ children }) {
  const [balance, setBalance] = useState();
  const [avaliableBalance, setAvaliableBalance] = useState();
  const [blockedBalance, setBlockedBalance] = useState();
  const [notifications, setNotifications] = useState([]);
  const [filteredNotifications, setFilteredNotifications] = useState();

  const { account, getProfile, logout } = useAuth();

  async function updateBalance() {
    await apiV1
      .patch(`/balance/update`)
      .catch((err) => {
        toast.error(getApiErrorMessage(err, 'Erro ao atualizar saldo.'));
      });
  }

  async function getBalance() {
    setBalance(0);
    setAvaliableBalance(0);
    setBlockedBalance(0);

    await updateBalance();

    const response = await apiV1.get('account/show');
    const balance = response.data.data.balance;

    setBalance(Number(balance.balance));
    setAvaliableBalance(Number(balance.avaliableBalance));
    setBlockedBalance(Number(balance.balance - balance.avaliableBalance));
  }

  async function editPassword(data) {
    await apiV1
      .patch("/account/password/update", data)
      .then(() => {
        toast.success("Senha alterado com sucesso.");
      })
      .catch((err) => {
        toast.error(getApiErrorMessage(err, 'Erro ao alterar a senha.'));
      });
  }

  async function editAvatar(file) {
    const avatar = await fileToBase64(file);

    await apiV1
      .patch("/person/avatar/update", { avatar : {
        key: `avatars/${Date.now() + file.name}`,
        file: avatar
      }})
      .then(async (response) => {
        await getProfile();
        toast.success(response.data.message);
      })
      .catch((err) => {
        toast.error(getApiErrorMessage(err, 'Erro ao atualizar a foto de perfil.'));
      });
  }

  async function deleteAvatar() {
    await apiV1
      .delete("/person/avatar")
      .then(async () => {
        await getProfile();
        toast.success("Foto de perfil removida com sucesso.");
      })
      .catch((err) => {
        toast.error(getApiErrorMessage(err, 'Erro ao remover a foto de perfil.'));
      });
  }

  async function deleteAccount(justification) {
    await apiV1
      .delete("/account/delete?justification=" + justification)
      .then(() => {
        toast.success("Conta encerrada com sucesso.");
        setTimeout(() => {
          logout();
        }, 2000);
      })
      .catch((err) => {
        toast.error(getApiErrorMessage(err, 'Erro ao encerrar a conta.'));
      });
  }

  async function getNotifications(page = 1) {
    await apiV1
      .get(`person/notifications?page=${page}`)
      .then((response) => {
        setNotifications(response.data.data);
        setFilteredNotifications(response.data.data);
      })
      .catch((err) => {
        toast.error(getApiErrorMessage(err, 'Erro ao buscar notificações'));
      });
  }

  return (
    <AccountContext.Provider
      value={{
        account,
        balance,
        avaliableBalance,
        blockedBalance,
        getBalance,
        editPassword,
        editAvatar,
        deleteAvatar,
        deleteAccount,

        getNotifications,
        notifications,
        setNotifications,
        filteredNotifications,
        setFilteredNotifications
      }}
    >
      {children}
    </AccountContext.Provider>
  );
}
